import React, { useState, useEffect } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import SubHeadersDataTable from "../../Student/Reusablecomponents/DataTable/SubHeadersDataTable";
import Loading from "../../Student/Reusablecomponents/Loading";

const CurrentRegistations = (props) => {
  const [RSData, SetRSData] = useState();
  const [InstituteValues, SetInstituteValues] = useState();
  const [Load, SetLoad] = useState(false);

  const GetInstituteData = async () => {
    SetInstituteValues([]);
    try {
      const response = await axiosInstance.get(
        `/NCLAdmin/GetSchoolRegCountByInstitute?InstituteId=${props.InstId?.Value}&RegionId=0&SocietyId=0`
      );

      const registered = {};
      for (let grade = 3; grade <= 12; grade++) {
        registered[`grade${grade}`] = 0;
      }
      const totalCounts = response.data.reduce(
        (sum, school) => {
          for (let grade = 3; grade <= 12; grade++) {
            registered[`grade${grade}`] += school[`grade${grade}`] || 0;
          }
          sum.totalRegCount += school.totalRegCount;
          return sum;
        },
        { totalRegCount: 0 }
      );
      const Totaldata = {
        schoolName: "Total",
        ...registered,
        ...totalCounts,
      };
      SetInstituteValues([Totaldata]);
      props.GetTotalcount(Totaldata);
      SetLoad((prev) => !prev);
    } catch (error) {
      console.error("Error fetching School data:", error);
      return [];
    }
  };

  const GetRStudents = async () => {
    SetLoad((prev) => !prev);
    GetInstituteData();
    SetRSData();
    try {
      const response = await axiosInstance.get(
        `/NCLAdmin/GetSchoolRegCountByInstitute?InstituteId=${
          props.InstId?.Value
        }&RegionId=${props.RegionId?.value || 0}&SocietyId=${
          props.SocietyId || 0
        }`
      );
      if (response.data.length > 0) {
        const registered = {};
        for (let grade = 3; grade <= 12; grade++) {
          registered[`grade${grade}`] = 0;
        }
        const totalCounts = response.data.reduce(
          (sum, school) => {
            for (let grade = 3; grade <= 12; grade++) {
              registered[`grade${grade}`] += school[`grade${grade}`] || 0;
            }

            sum.totalRegCount += school.totalRegCount;
            return sum;
          },
          { totalRegCount: 0 }
        );
        const Totaldata = {
          schoolName: "Total",
          ...registered,
          ...totalCounts,
        };
        SetRSData([Totaldata, ...response.data]);
        props.GetData(response.data);
      } else {
        SetRSData();
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    GetRStudents();
  }, [props.try]);

  const QCountcolumns = [
    { name: "School Name", selector: "schoolName", sortable: true },
    { name: "District", selector: "district", sortable: true },
    {
      name: "Grade wise Registered",
      subColumns: [
        { name: "3", selector: "grade3", sortable: true },
        { name: "4", selector: "grade4", sortable: true },
        { name: "5", selector: "grade5", sortable: true },
        { name: "6", selector: "grade6", sortable: true },
        { name: "7", selector: "grade7", sortable: true },
        { name: "8", selector: "grade8", sortable: true },
        { name: "9", selector: "grade9", sortable: true },
        { name: "10", selector: "grade10", sortable: true },
        { name: "11", selector: "grade11", sortable: true },
        { name: "12", selector: "grade12", sortable: true },
      ],
    },
    { name: "Total Registered", selector: "totalRegCount", sortable: true },
    {
      name: "Contact",
      subColumns: [
        { name: "Name", selector: "contactName", sortable: true },
        { name: "Number", selector: "contactPhone", sortable: true },
      ],
    },
  ];

  const InstituteColumns = [
    { name: "Grade", selector: "schoolName", sortable: true },
    {
      name: "Grade wise Registered",
      subColumns: [
        { name: "3", selector: "grade3", sortable: true },
        { name: "4", selector: "grade4", sortable: true },
        { name: "5", selector: "grade5", sortable: true },
        { name: "6", selector: "grade6", sortable: true },
        { name: "7", selector: "grade7", sortable: true },
        { name: "8", selector: "grade8", sortable: true },
        { name: "9", selector: "grade9", sortable: true },
        { name: "10", selector: "grade10", sortable: true },
        { name: "11", selector: "grade11", sortable: true },
        { name: "12", selector: "grade12", sortable: true },
      ],
    },
  ];

  return (
    <>
      <div className="SubHeading mt-3">Overall Grade wise Registered </div>
      {InstituteValues && (
        <SubHeadersDataTable
          data={InstituteValues}
          columns={InstituteColumns}
          className="NCLDataTable Card mt-2"
          ShowPagination={false}
          ShowPagecount={false}
        />
      )}

      {RSData && (
        <SubHeadersDataTable
          data={RSData}
          columns={QCountcolumns}
          DisplaySearch={true}
          ShowPagecount={false}
          className="NCLDataTable Card mt-3"
          ShowPagination={false}
        />
      )}
      {Load && <Loading />}
    </>
  );
};
export default CurrentRegistations;
